/**
 * @description ConfigType
 */
export enum ConfigType {

	/**
	 * @description Tag config property name
	 */
	TAG = 'tag',

	/**
	 * @description Skin config property name
	 */
	SKIN = 'skin'

}